<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense align="center" justify="center">
                <v-col cols="12" sm="6">
                    <v-list two-line subheader>
                        <v-subheader inset>Documentos</v-subheader>

                        <v-list-item v-for="item in listDocumentos" :key="item.title">
                            <v-list-item-avatar>
                                <v-icon :class="[item.iconClass]" v-text="item.icon"></v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title v-text="item.title"></v-list-item-title>
                                <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                                <v-tooltip bottom color="primary">
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon v-on="on" @click="verPDF(item)">
                                            <v-icon color="primary">visibility</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Ver PDF</span>
                                </v-tooltip>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col>
                    <modalPdfComponent :mostrar="objPdf.mostrar" :base64="objPdf.base64" :titulo="objPdf.titulo"/>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowDocumentosClienteComponent',
        inject: ['setData', 'setStep'],
        components:{
            modalPdfComponent: () => import('@/components/utilites/modalComponent.vue')
        },
        props: {
            active: {
                type: Boolean,
                default: false
            },
            idCliente: {
                type: String,
                default: ''
            },
            obBusqueda: {
                type: Object,
                default: {}
            },
            listDocumentos: {
                type: Array,
                default: () => []
            }
        },
        data: () => ({
            objPdf:{
                mostrar: false,
                base64: '',
                titulo: ''
            },
        }),
        watch: {
            active(val) {
                if (val && _.size(this.listDocumentos) == 0) {
                    this.onListarDocumentos();
                }
            }
        },
        created() {
            this.onListarDocumentos();
        },
        methods: {
            verPDF(v){
                var error = 'E';
                var o = { path: v.ruta, mini: false };

                axios.post(`${BASE_URI}administrador/repository-file/listar`,o)
                     .then((r)=>{
                        if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r, ['data', 'data'])) == 0) { error = 'I'; throw 'Error al leer el archivo PDF.'; }
                            this.objPdf.base64 = JSON.parse(JSON.stringify(r.data.data));
                            this.objPdf.titulo = v.nombreVisual;
                            this.objPdf.mostrar = true;
                     })
                     .catch((e)=>{
                        mensajesAlerta(e, error);
                     });
            },
            onListarDocumentos() {
                var error = 'E';
                var o = _.pick(this.obBusqueda, ['idCertificado', 'idPoliza']);

                axios.post(`${BASE_URI}administrador/documento/listar-documento-cliente`, o)
                    .then((r) => {
                        if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r, ['data', 'data'])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }
                            var l = _.cloneDeep(r.data.data);
                            var keys = _.keys(l);
                            var r = [];

                            _.map(keys,(v)=>{
                                    _.forEach(_.get(l,v,[]),(vv) =>{
                                        vv.icon      = 'description';
                                        vv.iconClass = 'grey lighten-1 white--text';
                                        vv.title     = vv.nombreVisual;
                                        vv.subtitle  = vv.nombreDocumento;
                                        r.push(vv);
                                    });
                                return v;
                            });
                            this.setData('listGeneral.listDocumentos', r);
                    })
                    .catch((e) => {
                        mensajesAlerta(e, error);
                    });
            },
            cerrarModalPdf(){
                this.objPdf.mostrar =  false;
                this.objPdf.base64 = '';
            }
        },
        provide(){
            return{
                cerrarModalPdf: this.cerrarModalPdf
            }
        }
    }
</script>